import { Action } from '../../../redux/redux.types';
import { COMPRESS_FLOW_ACTION_NAMES } from './compress-flow.actions';

export interface CompressFlowState {
  isInCompressFlow: boolean;
}

const defaultState: CompressFlowState = {
  isInCompressFlow: false,
};

export const compressFlow = (
  state: CompressFlowState = defaultState,
  { type }: Action,
): CompressFlowState => {
  switch (type) {
    case COMPRESS_FLOW_ACTION_NAMES.START_FLOW:
      return {
        isInCompressFlow: true,
      };

    case COMPRESS_FLOW_ACTION_NAMES.COMPRESS_FILES_START:
    case COMPRESS_FLOW_ACTION_NAMES.CANCEL_FLOW:
      return {
        isInCompressFlow: false,
      };

    default:
      return state;
  }
};
